import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainImage", "thumbnail", "link"]

  switch(event) {
    event.preventDefault()

    const thumbnail = event.currentTarget
    const imageUrl = thumbnail.dataset.imageUrl

    if (this.hasMainImageTarget && imageUrl) {
      this.mainImageTarget.src = imageUrl
      if (this.hasLinkTarget) this.linkTarget.href = imageUrl
      this.thumbnailTargets.forEach(thumb => {
        thumb.classList.toggle('active', thumb === thumbnail)
      })
    }
  }
}
